import React from 'react'

export default function About(props) {
  return (
    <div className="d-flex">
      <h1 className={`text-${props.mode==='light'?'dark':'light'}`}>About us</h1>
    </div>
  )
}
